import {
  DIARY_SLOT_ASSIGNEE_SEARCH_REQUEST,
  DIARY_SLOT_ASSIGNEE_SEARCH_SUCCESS,
  DIARY_SLOT_ASSIGNEE_SEARCH_FAIL,
} from "./actionType";

const initialState = {
  diarySlotAssigneeList: [],
  diarySlotAssigneeLoading: false,
  diarySlotAssigneeError: null,
};

const DiarySlotAssignee = (state = initialState, action) => {
  switch (action.type) {
    case DIARY_SLOT_ASSIGNEE_SEARCH_REQUEST:
      return { ...state, diarySlotAssigneeLoading: true, diarySlotAssigneeError: null };

    case DIARY_SLOT_ASSIGNEE_SEARCH_SUCCESS:
      return {
        ...state,
        diarySlotAssigneeLoading: false,
        diarySlotAssigneeList: action.payload?.diaryslotassignee_list || [],
      };

    case DIARY_SLOT_ASSIGNEE_SEARCH_FAIL:
      return { ...state, diarySlotAssigneeLoading: false, diarySlotAssigneeError: action.payload };

    default:
      return state;
  }
};

export default DiarySlotAssignee;
